/**
 * Per-route SEO metadata for the public website, keyed by exact pathname.
 *
 * Titles are kept under ~60 chars and descriptions ~150–160 chars for clean
 * SERP display. `Seo` appends " | Appraisal Delivery" automatically unless the
 * title already contains the brand. Transactional/auth pages are marked
 * `noIndex` so they stay out of search results.
 */

export const DEFAULT_PUBLIC_SEO = {
  title: 'Appraisal Delivery',
  description:
    'Connect with licensed, independent real estate appraisers for litigation, estate, tax, divorce, and insurance valuations on Appraisal Delivery.',
};

export const PUBLIC_SEO = {
  '/': {
    title: 'Appraisal Delivery | Real Estate Appraisers for Legal Matters',
    description:
      'Connect with licensed, independent real estate appraisers for litigation, estate, tax, divorce, and insurance valuations on Appraisal Delivery.',
  },
  '/for-professionals': {
    title: 'Find Appraisers for Legal & Professional Matters',
    description:
      'Attorneys, accountants, and fiduciaries: search verified independent appraisers by location, property type, and specialty for litigation and estate matters.',
  },
  '/for-appraisers': {
    title: 'For Appraisers — Grow Your Professional Practice',
    description:
      'Join Appraisal Delivery free to showcase your credentials and connect with attorneys and fiduciaries seeking independent valuations — you set your own fees.',
  },
  '/pricing': {
    title: 'Pricing — Plans & Per-Order Fees',
    description:
      'Transparent pricing for Appraisal Delivery: an annual professional subscription plus a flat $25 per-order technology fee. Appraisers join free, no fee markups.',
  },
  '/how-it-works': {
    title: 'How It Works — Find & Engage Appraisers',
    description:
      'See how Appraisal Delivery works: search appraisers, review credentials, connect directly, and exchange completed reports securely through the platform.',
  },
  '/about': {
    title: 'About Appraisal Delivery',
    description:
      'Learn about Appraisal Delivery, the technology platform connecting professionals with independent real estate appraisers for non-lending valuations.',
  },
  '/terms': {
    title: 'Terms of Service',
    description:
      'Read the Appraisal Delivery Terms of Service governing use of our platform connecting professionals with independent real estate appraisers.',
  },
  '/privacy': {
    title: 'Privacy Policy',
    description:
      'Read the Appraisal Delivery Privacy Policy to learn how we collect, use, and protect your information on our valuation platform.',
  },
  '/contact': {
    title: 'Contact Us',
    description:
      "Get in touch with the Appraisal Delivery team — we're here to answer questions about the platform, accounts, and assignments.",
  },
  '/pro-video': {
    title: 'Video: Appraisal Delivery Overview',
    description:
      'Watch a short overview of Appraisal Delivery: how attorneys and other professionals find, engage, and work with qualified real estate appraisers.',
    image: 'https://i.ytimg.com/vi/BAZheNMhDco/maxresdefault.jpg',
  },
  '/login': {
    title: 'Sign In',
    description:
      'Sign in to your Appraisal Delivery account to manage assignments, messages, and secure document delivery.',
    noIndex: true,
  },
  '/signup': {
    title: 'Sign Up — Create Your Account',
    description:
      'Create your Appraisal Delivery account to connect with independent appraisers or to showcase your appraisal practice.',
  },
  '/signup/professional': {
    title: 'Sign Up — For Professionals',
    description:
      'Create a professional account to find and engage licensed independent appraisers for litigation, estate, tax, and insurance matters.',
  },
  '/signup/appraiser': {
    title: 'Sign Up — For Appraisers',
    description:
      'Create a free appraiser profile to showcase your credentials and connect with attorneys and fiduciaries seeking independent valuations.',
  },
  '/signup/success': {
    title: 'Account Created',
    description: 'Your Appraisal Delivery account has been created.',
    noIndex: true,
  },
  '/reset-password': {
    title: 'Reset Password',
    description: 'Reset the password for your Appraisal Delivery account.',
    noIndex: true,
  },
  '/reactivate-account': {
    title: 'Reactivate Account',
    description: 'Reactivate your Appraisal Delivery account.',
    noIndex: true,
  },
};
